import { Alert } from 'antd';

/** Nota honesta sobre el carácter provisional de ingresos/energía/potencia. */
export function ProvisionalDataNotice() {
  return (
    <Alert
      type="warning"
      showIcon
      message="Datos provisionales"
      description="Los ingresos se estiman como energía de hoy × tarifa provisional configurable: aún no existen tarifas por estación (US 2.4). La energía es un piso calculado desde Transactions.totalKwh del core y la potencia instantánea no está disponible hasta que se consuman MeterValues (TG-93/94)."
    />
  );
}
